import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import MerchPlannerIndex from '../components/tasks/MerchPlannerIndex.vue'
import TasksIndex from '../components/tasks/TasksIndex.vue'

//Translations

export default /*#__PURE__*/_defineComponent({
  __name: 'PageMyTasks',
  setup(__props) {

const { t } = useI18n({ useScope: 'global' })
const storeItemsLabel = (key: string) => t(`tables.${key}`)

//Tabs
const tab = ref('tasks')

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-pt-sm" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        class: "text-grey",
        "active-color": "secondary",
        "indicator-color": "secondary",
        align: "left",
        "narrow-indicator": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab, {
            name: "tasks",
            label: storeItemsLabel('tasks')
          }, null, 8, ["label"]),
          _createVNode(_component_q_tab, {
            name: "merchPlanner",
            label: storeItemsLabel('merchPlanner')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_tab_panels, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
        animated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, {
            "keep-alive": "",
            name: "tasks"
          }, {
            default: _withCtx(() => [
              _createVNode(TasksIndex)
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            "keep-alive": "",
            name: "merchPlanner"
          }, {
            default: _withCtx(() => [
              _createVNode(MerchPlannerIndex)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})